export const isLabelMatched = (obj, labelToMatch) => {
  let isLabelMatched = false;
  Object.keys(obj).forEach((key) => {
    if (key === labelToMatch) {
      isLabelMatched = true;
    }
  });
  return isLabelMatched;
};
